module.exports = __webpack_public_path__ + "img/left-right.eccd334a.svg";